import { HiOutlineCalendar, HiOutlineChartBar } from 'react-icons/hi';
import { pathnames } from 'routes/yearlyCalendar';

const yearlyCalendarMenu = [
  {
    name: 'Schedule Plan',
    url: pathnames.schedulePlan,
    icon: HiOutlineCalendar,
    role: ['superadmin', 'admin', 'user'],
    children: []
  },
  {
    name: 'Reports',
    url: pathnames.reports,
    icon: HiOutlineChartBar,
    role: ['superadmin', 'admin', 'user'],
    children: []
  }
];

export default yearlyCalendarMenu;
